import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

// export const HeaderSection = styled("header")`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   z-index: 1000;
//   background: white;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
// `;

// Separate the main header content
export const MainHeader = styled.div`
  background: white;
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

// Banner positioned below the main header
// export const PromoBanner = styled.div`
//   position: relative;
//   width: 100%;
//   height: 45px;
//   background: linear-gradient(135deg, #2E186A 0%, #8A6FE6 100%);
//   color: white;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden;

//   .banner-content {
//     text-align: center;
//     padding: 0 60px;
//     width: 100%;
//   }

//   .banner-text {
//     font-size: 13px;
//     font-weight: 500;
//     letter-spacing: 0.5px;
//     color: #ffffff;
//     text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
//   }

//   .banner-nav {
//     position: absolute;
//     top: 50%;
//     transform: translateY(-50%);
//     background: rgba(255, 255, 255, 0.1);
//     border: none;
//     color: white;
//     width: 25px;
//     height: 25px;
//     border-radius: 50%;
//     cursor: pointer;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     transition: all 0.3s ease;
//     font-size: 14px;

//     &:hover {
//       background: rgba(255, 255, 255, 0.2);
//       transform: translateY(-50%) scale(1.1);
//     }

//     &.prev {
//       left: 10px;
//     }

//     &.next {
//       right: 10px;
//     }
//   }

//   @media (max-width: 890px) {
//     height: 40px;
    
//     .banner-content {
//       padding: 0 50px;
//     }

//     .banner-text {
//       font-size: 12px;
//       line-height: 1.3;
//     }

//     .banner-nav {
//       width: 20px;
//       height: 20px;
//       font-size: 12px;

//       &.prev {
//         left: 5px;
//       }

//       &.next {
//         right: 5px;
//       }
//     }
//   }

//   @media (max-width: 480px) {
//     height: 35px;
    
//     .banner-content {
//       padding: 0 35px;
//     }

//     .banner-text {
//       font-size: 11px;
//       line-height: 1.2;
//     }
//   }
// `;

// Keep all your existing styled components...
export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

// Add the TopBanner styled component
export const TopBanner = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .banner-content {
    text-align: center;
    padding: 0 60px;
    width: 100%;
  }

  .banner-text {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: #ffffff;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  }

  .banner-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 12px;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: translateY(-50%) scale(1.1);
    }

    &.prev {
      left: 10px;
    }

    &.next {
      right: 10px;
    }
  }

  @media (max-width: 890px) {
    height: 45px;
    
    .banner-content {
      padding: 0 45px;
    }

    .banner-text {
      font-size: 11px;
      line-height: 1.3;
    }

    .banner-nav {
      width: 18px;
      height: 18px;
      font-size: 10px;

      &.prev {
        left: 5px;
      }

      &.next {
        right: 5px;
      }
    }
  }

  @media (max-width: 480px) {
    height: 40px;
    
    .banner-content {
      padding: 0 35px;
    }

    .banner-text {
      font-size: 10px;
      line-height: 1.2;
    }
  }
`;

// Update your existing PromoBanner to add bold styling
export const PromoBanner = styled.div`
  position: relative;
  width: 100%;
  height: 45px;
  background: linear-gradient(135deg, #2E186A 0%, #8A6FE6 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .banner-content {
    text-align: center;
    padding: 0 60px;
    width: 100%;
  }

  .banner-text {
    font-size: 25px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: #ffffff;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);

    &.bold {
      font-weight: 700; /* Bold styling for $25 message */
      font-size: 25px;
    }
  }

  @media (max-width: 890px) {
    height: 50px;
    
    .banner-content {
      padding: 0 50px;
    }

    .banner-text {
      font-size: 12px;
      line-height: 1.3;

      &.bold {
        font-size: 13px;
      }
    }
  }

  @media (max-width: 480px) {
    height: 49px;
    
    .banner-content {
      padding: 0 35px;
    }

    .banner-text {
      font-size: 11px;
      line-height: 1.2;

      &.bold {
        font-size: 12px;
      }
    }
  }
`;

// Update HeaderSection to accommodate both banners
export const HeaderSection = styled("header")`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;
